// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.challenge-container {
    border: none;
    padding: 0px;
    height: 90vh;
    overflow: hidden;
    width: unset; /* Remove default width added to dialog elements. In Chrome, it was 300px. */
}

.challenge-container::backdrop {
    background-color: gray;
    opacity: 0.75;
}

.challenge-container iframe {
    border: none;
    height: 100%;
    width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/lib/index.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,YAAY,EAAE,4EAA4E;AAC9F;;AAEA;IACI,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,WAAW;AACf","sourcesContent":[".challenge-container {\r\n    border: none;\r\n    padding: 0px;\r\n    height: 90vh;\r\n    overflow: hidden;\r\n    width: unset; /* Remove default width added to dialog elements. In Chrome, it was 300px. */\r\n}\r\n\r\n.challenge-container::backdrop {\r\n    background-color: gray;\r\n    opacity: 0.75;\r\n}\r\n\r\n.challenge-container iframe {\r\n    border: none;\r\n    height: 100%;\r\n    width: 100%;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
